var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("th",_vm._b({tag:"component",class:_vm.classComputed,style:(_vm.styleComputed),on:{"click":function($event){return _vm.onClick($event)}}},'component',_vm.$attrs,false),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }